import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from './i18n'

// 全局樣式
import './assets/main.css'

// 部署後舊頁面去載已不存在的舊 chunk 時 (Vite 動態 import 失敗), 自動重整拿新版,
// 不要讓使用者面對「按了沒反應」
window.addEventListener('vite:preloadError', () => {
  window.location.reload()
})

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)

app.mount('#app')
